import { Flex } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'

import {
    AverageSound,
    HighSound,
    NoSound,
} from '../components/Icons/attempt.jsx'

const AudioPreviewer = ({ audioStream }) => {
    const [intensity, setIntensity] = useState(0)
    const analyzerRef = useRef(null)
    const gainRef = useRef(null)

    const getVolume = dataArray => {
        const values =
            dataArray.reduce((acc, val) => acc + val, 0) / dataArray.length
        return Math.round(values * 100)
    }
    useEffect(() => {
        if (audioStream) {
            const audioContext = new AudioContext()
            const source = audioContext.createMediaStreamSource(audioStream)
            const analyzer = audioContext.createAnalyser()
            analyzer.fftSize = 2048
            analyzer.smoothingTimeConstant = 0.3
            source.connect(analyzer)

            const gain = audioContext.createGain()
            gain.gain.value = 0
            analyzer.connect(gain)
            gain.connect(audioContext.destination)

            analyzerRef.current = analyzer
            gainRef.current = gain
        }

        return () => {
            if (analyzerRef.current) {
                analyzerRef.current.disconnect()
            }
            if (gainRef.current) {
                gainRef.current.disconnect()
            }
        }
    }, [audioStream])

    useEffect(() => {
        const interval = setInterval(() => {
            if (analyzerRef.current) {
                const bufferLength = analyzerRef.current.frequencyBinCount
                const dataArray = new Uint8Array(bufferLength)
                analyzerRef.current.getByteFrequencyData(dataArray)
                const volume = getVolume(dataArray)
                setIntensity(volume > 1400 ? 2 : volume > 800 ? 1 : 0)
            }
        }, 100)

        return () => clearInterval(interval)
    }, [])

    return (
        <Flex
            border={'1px solid #7C6A96'}
            borderRadius={'50%'}
            bg={'#7C6A96'}
            p={1}
        >
            {intensity === 0 && <NoSound fontSize={'20px'} color={'white'} />}
            {intensity === 1 && (
                <AverageSound fontSize={'20px'} color={'white'} />
            )}
            {intensity === 2 && <HighSound fontSize={'20px'} color={'white'} />}
        </Flex>
    )
}

export default AudioPreviewer